var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6.45187C15 11.4419 11.1117 14.0198 9.34981 14.9318C8.94747 15.1401 8.5 14.8452 8.5 14.3985V13.5422C8.5 13.1896 8.20813 12.9071 7.85093 12.872C4.56582 12.5487 2 9.79771 2 6.45187C2 2.8886 4.91015 0 8.5 0C12.0899 0 15 2.8886 15 6.45187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/ChatBubble.acd160620c2b70c6fc16e7d6a8eee61a.svg";
export { ForwardRef as ReactComponent };